module.exports = function (html) {
  return html.replace(/(<([^>]+)>)/gi, ' ');
};

module.exports.stripOuterTags = function (html) {
  return html.replace(/^(<([^>]+)>)/i, '').replace(/(<([^>]+)>)$/i, '');
};
